import * as React from 'react';

function SvgUnactive(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#unactive_svg__clip0_288_422)">
        <path d="M2.667 3h8v1h2.666v11.333H4v-3H2.667V3z" fill="#BFBFBF" />
        <path
          d="M12.803 6.602a1.848 1.848 0 112.613 2.614L12.9 11.732l-2.613-2.614 2.515-2.516z"
          fill="#BFBFBF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 .767C1.319.767.767 1.319.767 2v10c0 .681.552 1.233 1.233 1.233h1.433v1.434c0 .68.552 1.233 1.234 1.233h8c.68 0 1.233-.552 1.233-1.233v-2.334a.567.567 0 00-1.133 0v2.334a.1.1 0 01-.1.1h-8a.1.1 0 01-.1-.1v-10a.1.1 0 01.1-.1h8a.1.1 0 01.1.1v1a.567.567 0 001.133 0v-1c0-.681-.552-1.234-1.233-1.234h-1.434V2c0-.681-.552-1.233-1.233-1.233H2zm8.1 2.666V2a.1.1 0 00-.1-.1H2a.1.1 0 00-.1.1v10a.1.1 0 00.1.1h1.433V4.667c0-.681.552-1.234 1.234-1.234H10.1zM6.667 6.767c0-.313.253-.567.566-.567H10.1a.567.567 0 110 1.133H7.233a.567.567 0 01-.566-.566zm-.434 2.1a.567.567 0 000 1.133h2.2a.567.567 0 100-1.133h-2.2zm-.566 3.566c0-.313.253-.566.566-.566h.534a.567.567 0 110 1.133h-.534a.567.567 0 01-.566-.567zm9.203-5.177a.833.833 0 00-1.179 0l-.59.59 1.18 1.178.588-.59a.833.833 0 000-1.178zm-2.71 1.532l-3.3 3.3 1.178 1.178 3.3-3.3-1.179-1.178zm-2.123 4.478l-1.324.306a.133.133 0 01-.16-.16l.306-1.324 1.178 1.178z"
          fill="#595959"
        />
      </g>
      <defs>
        <clipPath id="unactive_svg__clip0_288_422">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgUnactive;
